// extracted by mini-css-extract-plugin
export default {"ShopsWrapper":"styles_ShopsWrapper__JXpdY","shopsButton":"styles_shopsButton__qnKuq","inactive":"styles_inactive__jl+QQ"};